import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 5px;
    margin-top: 10px;
  }
`;

export const Box = styled.div`
  border-radius: 21px;
  padding: 20px 15px;
  background-color: ${({ theme }) => theme.palette.primary.background};
`;

export const RestoredAdDescription = styled.div`
  margin-bottom: 15px;
`;

export const PromotionTitle = styled(Typography.Title)`
  font-size: 16px;
  margin-bottom: 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: 15px;
  }
`;

export const AdNumber = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  border-radius: 7px;
  height: 39px;
  letter-spacing: 3px;
  font-size: 15px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.primary.labels};
  background-color: ${({ theme }) => theme.palette.secondary.background};
`;

export const PromotionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ActionsContainer = styled.div`
  padding-top: 10px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 20px 0 25px;
  }
`;
